import { useEffect, useState } from 'react';
import { Bell, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button, EmptyState, LoadingState } from '../components/ui';
import { loadNotifications } from '../lib/studentUtilities';
import type { ParseRecord } from '../lib/parse';

const PAGE_SIZE = 12;

export function StudentNotifications() {
  const [page, setPage] = useState(0);
  const [items, setItems] = useState<ParseRecord[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    void (async () => {
      try {
        const { items: rows, total: count } = await loadNotifications(page, PAGE_SIZE);
        if (active) { setItems(rows); setTotal(count); }
      } finally { if (active) setLoading(false); }
    })();
    return () => { active = false; };
  }, [page]);

  const pageCount = Math.max(1, Math.ceil(total / PAGE_SIZE));
  return <div className="utility-page">
    <section className="utility-hero"><div className="utility-icon"><Bell size={28} /></div><div><h1>Announcements</h1><p>{total ? `${total} updates from AyurGuide` : 'Updates from AyurGuide appear here.'}</p></div></section>
    <section className="detail-section">
      {loading ? <LoadingState /> : items.length ? <>
        <div className="notes-list">{items.map((item) => <article className="solution-card" key={item.objectId}>
          <div className="question-number"><Bell size={13} /> {String(item.Name ?? 'Announcement')}</div>
          <p className="detail-description">{String(item.Description ?? '')}</p>
          <small className="note-date">{item.createdAt ? new Date(item.createdAt).toLocaleString() : ''}</small>
        </article>)}</div>
        <div className="pagination-row">
          <Button variant="ghost" icon={ChevronLeft} disabled={page === 0} onClick={() => setPage((value) => Math.max(0, value - 1))}>Newer</Button>
          <span className="pagination-label">Page {page + 1} of {Math.max(1, Math.ceil(total / PAGE_SIZE))}</span>
          <Button variant="ghost" disabled={page + 1 >= pageCount} onClick={() => setPage((value) => value + 1)}>Older <ChevronRight size={16} /></Button>
        </div>
      </> : <EmptyState icon={Bell} title="You are all caught up" description="Announcements about tests, results, and batches will appear here." />}
    </section>
  </div>;
}
